import Advertisement, { AdPage, AdType, PlaceSectionForAd } from '@web/components/Advertisement/Advertisement'
import { MyMe_UserFragment } from '@web/federation/gql/graphql'
import BookingNotificationSection from '@web/pages/v5/home/BookingNotificationSection'
import { DailyBriefingSection } from '@web/pages/v5/home/DailyBriefingSection'
import { DdayRecommendPlacesSection } from '@web/pages/v5/home/DdayRecommendPlacesSection'
import FavoritesSection from '@web/pages/v5/home/FavoriteSection/FavoritesSection'
import MissionSection from '@web/pages/v5/home/MissionSection'
import RecentOrderBookingSection from '@web/pages/v5/home/RecentOrderBookingSection'
import TimelineSection from '@web/pages/v5/home/TimelineSection/index.page'
import { UpcomingSection } from '@web/pages/v5/home/UpcomingSection'

/**
 * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=2619148695
 * web의 섹션 순서 참고
 */

interface Props {
  user: MyMe_UserFragment | null | undefined
}

const FirstZone = ({ user }: Props) => {
  return (
    <>
      <DailyBriefingSection />
      <UpcomingSection />
      <BookingNotificationSection user={user} />
      <DdayRecommendPlacesSection />
      <MissionSection />
      <TimelineSection user={user} />
      <PlaceSectionForAd isTransparentBg>
        <Advertisement
          adSlotElementId="home_tab_mid_ad"
          type={AdType.M_SUB}
          page={AdPage.HOME_TAB}
          userIdno={user?.idno}
          marginTop={12}
        />
      </PlaceSectionForAd>
      <RecentOrderBookingSection user={user} />
      <FavoritesSection user={user || undefined} />
    </>
  )
}

export default FirstZone
